import { RoleModuleConfig } from './types';
import { SiteSubjectsListSlice } from '@restore/SiteSubjectsList/SiteSubjectsList.slice';
import { siteUploadSlice } from '@restore/siteUpload/siteUpload.slice';
import { SiteSubjectsListSaga } from '@restore/SiteSubjectsList/SiteSubjectsList.saga';
import { siteUploadSaga } from '@restore/siteUpload/siteUpload.saga';
import { siteUserQueriesSlice } from '../siteUserQueries/siteUserQueries.slice';
import { siteUserQueriesSaga } from '../siteUserQueries/siteUserQueries.saga';

export const siteModules: RoleModuleConfig = {
  slices: [SiteSubjectsListSlice, siteUploadSlice, siteUserQueriesSlice],
  sagas: {
    SiteSubjectsListSaga,
    siteUploadSaga,
    siteUserQueriesSaga,
  },
};
